/**
 *  Summary comportment
 *  Use jQuery
 */

;(function summary($) {

    $(document).ready(init);

    var SUMMARY = '.Summary';
    var ITEM = '.Summary-link';
    var SECTION = '.Section';
    var SECTIONTITLE = '.Section-title';

    var DELAY = 50;
    var BREAKPOINT = 1100;

    var titleArray = [];

    function init() {
        var sections = $(SECTION);

        if (sections.length > 1 && $(window).width() >= BREAKPOINT) {
            // Create the summary items
            createSummary();

            // Add a smooth scroll on anchor
            smoothScroll();

            // Change summary item state on scroll / click
            changeState();
            $(window).on('scroll', changeState);
        }
    }

    function createSummary() {
        var section = $(SECTION);

        section.each(function(index) {
            // Add an id to the section
            $(this).attr('id', index);

            // Create an array with the titles
            var title = $(this).find(SECTIONTITLE);
            titleArray.push(title.text());
        });

        // Create the items with the arrays and add a href link to the anchor
        $.each(titleArray, function(index) {
            $(SUMMARY).append(
                '<li class="Summary-item">' +
                    '<a class="Summary-link" href="#' + index + '" data-state="inactive">' +
                        '<span>' +
                            titleArray[index] +
                        '</span>' +
                    '</a>' +
                '</li>'
            );
        });
    }

    function smoothScroll() {
        $(ITEM + '[href*="#"]:not([href="#"])').click(function() {
            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
                if (target.length) {
                    $('html, body').animate({
                        scrollTop: target.offset().top - 280
                    }, 1000);
                    return false;
                }
            }
        });
    }

    var changeState = debounce(function() {
        var w = $(window);
        var section = $(SECTION);
        var distances = [];
        var items = $(ITEM);
        var value = w.scrollTop() + (w.height() / 2);

        //  Create the table of values
        section.each(function(index) {
            var distance = $(this).offset().top;
            distances.push({index: index, distance: distance});
        });

        // Create a filtered table with only values > "value"
        var filtered = distances.filter(function(el) {
            return el.distance < value;
        });

        var ind =  filtered[filtered.length - 1].index;
        var item = $(ITEM + '[href="#' + ind + '"]');

        if (item.attr('data-state') === 'inactive' || item.attr('data-state') === 'passed') {
            items.attr('data-state', 'inactive');
            item.attr('data-state', 'active');

            for (var a = ind - 1; a > -1; a--) {
                $(ITEM + '[href="#' + a + '"]').attr('data-state', 'passed')
            }
        } else {
            return;
        }
    }, DELAY);

}(jQuery));
